import { cn } from '@/utils';
import { CloseIcon } from '@/components/Icons';
import { useCofheFloatingButtonContext } from './CofheFloatingButtonContext';
import { FhenixLogoIcon } from '../FhenixLogoIcon';
import { usePortalUI, usePortalStatuses } from '@/stores';
import type { CofheStatusVariant } from './types';

const statusVariantStyles: Record<CofheStatusVariant, string> = {
  error: 'border-red-500',
  warning: 'border-yellow-500',
  info: 'border-blue-500',
};

export const FloatingButtonComponent: React.FC<{ onClick: () => void }> = ({ onClick }) => {
  const { theme } = useCofheFloatingButtonContext();
  const { statuses } = usePortalStatuses();
  const { portalOpen } = usePortalUI();

  const topStatusVariant = statuses[statuses.length - 1]?.variant;

  return (
    <button
      onClick={onClick}
      className={cn(
        'cofhe-panel cofhe-floating-icon',
        'w-12 h-12',
        'flex items-center justify-center cursor-pointer flex-shrink-0',
        'focus:outline-none',
        statusVariantStyles[topStatusVariant]
      )}
    >
      <div className="flex items-center justify-center">
        {portalOpen && <CloseIcon className="w-6 h-6" />}
        {!portalOpen && <FhenixLogoIcon theme={theme} className="w-10 h-10" />}
      </div>
    </button>
  );
};
